import {
    SCHEDULE_GET_REQUEST,
    SCHEDULE_GET_RECEIVE
} from "../config/actions";
import ScheduleHelper from '../helpers/scheduleHelper';

let defaultState = {
    locations: [],
    startAt: null,
    endAt: null,
    loading: false,
    loaded: false,
    workTypes: [],
    locationGroups: []
};

const scheduleReducer = (state = defaultState, action) => {
    let locations;
    switch (action.type) {
        case SCHEDULE_GET_REQUEST:
            return Object.assign({}, state, {
                loading: true
            });
        case SCHEDULE_GET_RECEIVE:
            locations = JSON.parse(JSON.stringify(action.data.locations));
            locations = ScheduleHelper.prepareLocationRendering(locations);
            return Object.assign({}, state, {
                locations: locations,
                startAt: action.data.startAt,
                endAt: action.data.endAt,
                workTypes: action.data.workTypes,
                locationGroups: action.data.locationGroups,
                loading: false,
                loaded: true
            });
        default:
            return state;
    }
};

export default scheduleReducer;
